import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section id="categories" className="relative py-20 md:py-28 bg-foreground-950 overflow-hidden">
      <div className="absolute inset-0 opacity-8">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20texture%20with%20subtle%20fabric%20weave%20patterns%20and%20leather%20grain%20details%20blended%20artistically%2C%20deep%20charcoal%20base%20with%20warm%20undertones%2C%20textured%20overlay%20background%2C%20minimalist%20dark%20aesthetic&width=1200&height=800&seq=cat-bg-v2-024&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-8"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-8 mb-14">
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/25 text-white text-sm font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              Categories
              <i className={`text-sm transition-transform ${dropdownOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
            </button>

            {dropdownOpen && (
              <div className="absolute top-full mt-2 left-0 w-72 bg-background-50 rounded-xl border border-background-200 shadow-lg py-2 z-50 max-h-96 overflow-y-auto">
                {categories.map((cat) => (
                  <a
                    key={cat.slug}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer"
                    onClick={() => setDropdownOpen(false)}
                  >
                    <img src={cat.image} alt={cat.name} className="w-10 h-10 rounded-lg object-cover shrink-0" />
                    <span className="whitespace-nowrap flex-1">{cat.name}</span>
                    <i className="ri-arrow-right-up-line text-xs text-foreground-400 shrink-0"></i>
                  </a>
                ))}
              </div>
            )}
          </div>

          <div className="lg:text-right">
            <h2 className="font-heading text-3xl md:text-5xl text-white leading-tight">
              Trending pandabuy<br />Spreadsheet Categories
            </h2>
          </div>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-52 md:w-60 rounded-xl bg-background-50 overflow-hidden group cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} pandabuy spreadsheet category`}
                  title={`pandabuy spreadsheet ${cat.name} finds`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{cat.name}</h3>
                <span className="text-xs text-accent-600 mt-1 inline-flex items-center gap-1 whitespace-nowrap">
                  View Spreadsheet
                  <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}